export class Country
{
    continent: string = "";
    name: string = "";
    iso2: string = "";
    iso3: string = "";
    code: string = "";
    european_union: boolean = false;
    coeff: number;
    other: string[] = [];
    constructor(continent: string, name: string, iso2: string, iso3: string, code: string, european_union: boolean, coeff: number, other: string[] = [])
    {
        this.continent = continent;
        this.name = name;
        this.iso2 = iso2;
        this.iso3 = iso3;
        this.code = code;
        this.european_union = european_union;
        this.coeff = coeff;
        this.other = other;
    }
}